module.exports = __webpack_public_path__ + "img/ru-top.37c3cb67.png";